import { GeoJSONLayer } from "react-mapbox-gl";
import { Route as RouteType } from "../api/directions.type";

import { useRoutes } from "../state/RouteContext";
import { LongLat } from "../api/geoLocation.type";
import { useEffect } from "react";
import { trackEvent } from "../tracking/utils";

export function Route({ styleLoaded = true }: { styleLoaded?: boolean }) {
  const { routes, journey, selectedRoute, setSelectedRoute } = useRoutes();

  useEffect(() => {
    if (selectedRoute) {
        const { distance, duration } = selectedRoute;
        trackEvent("Route View", { distance, duration, from: journey?.from?.placeName, to: journey?.to?.placeName });
    }
  }, [selectedRoute]);

  if (!styleLoaded || !routes?.length || !journey?.from || !journey.to) return null;

  return (
    <>
      {routes.map((route: RouteType, i: number) => {
        const isSelected = route === selectedRoute;
        const color = isSelected ? "#0067FF" : "#929497";
        const lineData = {
          type: "Feature" as const,
          properties: {},
          geometry: route.geometry,
        };
        const labelData = {
          type: "Feature" as const,
          properties: {
            label: getInKm(route.distance),
          },
          geometry: {
            type: "Point" as const,
            coordinates: getMiddleCoordinate(route.geometry.coordinates),
          },
        };

        return (
          <div key={`route-${i}-${route.distance}`}>
            {/* Visible route line */}
            <GeoJSONLayer
              data={lineData}
              linePaint={{
                "line-color": color,
                "line-width": 4,
                "line-opacity": isSelected ? 0.8 : 0.6,
              }}
              lineLayout={{ "line-join": "round" }}
              lineOnClick={() => setSelectedRoute(route)}
            />

            {/* Wider invisible clickable hit area */}
            <GeoJSONLayer
              data={lineData}
              linePaint={{
                "line-color": color,
                "line-width": 18,
                "line-opacity": 0.01,
              }}
              lineLayout={{ "line-join": "round" }}
              lineOnClick={() => setSelectedRoute(route)}
            />

            {/* Distance label */}
            <GeoJSONLayer
              data={labelData}
              symbolLayout={{
                "text-field": ["get", "label"],
                "text-size": 10,
                "text-font": ["Poppins Regular"],
                "text-anchor": "right",
                "icon-image": "label-icon-2",
                "icon-text-fit": "both",
                "icon-text-fit-padding": [6, 6, 6, 6],
                "icon-allow-overlap": true,
                "icon-ignore-placement": true,
                "text-allow-overlap": true,
                "text-ignore-placement": true,
              }}
              symbolPaint={{
                "text-color": "#031B4E",
              }}
              symbolOnClick={() => setSelectedRoute(route)}
            />
          </div>
        );
      })}
    </>
  );
}

function getInKm(distanceInMeter: number): string {
  return `${(distanceInMeter / 1000).toFixed(1)} km`;
}

function getTravelDuration(timeInSeconds: number): string {
  // TODO seems to be awfully long?
  const timeInMin = timeInSeconds / 60;

  return timeInMin <= 60
    ? `${(timeInSeconds / 60).toFixed()} min`
    : `${(timeInMin / 60).toFixed()} uur`;
}

function getMiddleCoordinate(coordinates: LongLat[]): LongLat {
  const middleIndex = +(coordinates.length / 2).toFixed();

  return coordinates[middleIndex];
}
